<div class="logo">
    <img src="/assets/img/logo-psd-light.png" alt="" width="160" *ngIf="!platform"/>
    <img src="https://config.prosoccerdata.com/logos/extra_groot/{{ platform.clubId }}.png?v=1" alt="" *ngIf="platform"/>
</div>